module.exports = __webpack_public_path__ + "img/widget-empty.973b5e3a.png";